import { render } from "./AppCheckbox.vue?vue&type=template&id=2897c80c&scoped=true"
import script from "./AppCheckbox.vue?vue&type=script&lang=js"
export * from "./AppCheckbox.vue?vue&type=script&lang=js"

import "./AppCheckbox.vue?vue&type=style&index=0&id=2897c80c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2897c80c"]])

export default __exports__